var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.documentTypes.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _vm.documentTypes.length > 0
        ? _c(
            "div",
            [
              _c("section-title", {
                staticClass: "section-title__extended mt-4",
                attrs: {
                  content: "Listado de Documentos por Tipo de Proveedor"
                }
              }),
              _c(
                "q-tab",
                { ref: "qTab" },
                _vm._l(_vm.documentTypes, function(item, index) {
                  return _c(
                    "q-tab-item",
                    {
                      key: item.recruitmentTypeId,
                      attrs: {
                        active: index === 0,
                        lazy: "",
                        tabindex: item.recruitmentTypeId,
                        title: item.recruitmentTypeName
                      },
                      on: {
                        click: () =>
                          _vm.getDocumentTypeForCreation(item.recruitmentTypeId)
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end mb-3" },
                        [
                          _vm.canEditDocuments &&
                          !_vm.addingDocument &&
                          !_vm.readOnly
                            ? _c("action-button", {
                                staticClass: "mr-2",
                                class: _vm.isDragAndDropEnable
                                  ? "custom-reorganize-btn text-white"
                                  : "outline-dark-gray",
                                attrs: {
                                  i: "far fa-sort-numeric-up",
                                  text: _vm.isDragAndDropEnable
                                    ? "Finalizar Reorganización"
                                    : "Reorganizar Documentos"
                                },
                                on: { click: _vm.reorganize }
                              })
                            : _vm._e(),
                          _vm.canEditDocuments &&
                          !_vm.addingDocument &&
                          !_vm.readOnly &&
                          !_vm.isDragAndDropEnable
                            ? _c("action-button", {
                                attrs: {
                                  i: "fas fa-file-plus",
                                  text: "Añadir Documento",
                                  variant: "success"
                                },
                                on: { click: () => (_vm.addingDocument = true) }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.addingDocument
                        ? _c("add-document", {
                            staticClass: "mb-3",
                            attrs: {
                              "document-types": _vm.documentTypeForCreation
                            },
                            on: {
                              "on-cancel": () => (_vm.addingDocument = false),
                              "on-create": function($event) {
                                return _vm.onAddDocumentHandler($event)
                              }
                            }
                          })
                        : _vm._e(),
                      _c(
                        "draggable",
                        {
                          attrs: {
                            disabled: !_vm.isDragAndDropEnable,
                            "force-fallback": "",
                            "ghost-class": "ghost"
                          },
                          model: {
                            value: item.documents,
                            callback: function($$v) {
                              _vm.$set(item, "documents", $$v)
                            },
                            expression: "item.documents"
                          }
                        },
                        _vm._l(item.documents, function(item) {
                          return _c("document-row", {
                            key: item.proposalDocumentTypeId,
                            attrs: {
                              "draggable-enabled": _vm.isDragAndDropEnable,
                              "permission-to-actions":
                                "provider.biddocumentation.create",
                              "read-only": _vm.readOnly,
                              value: item
                            },
                            on: {
                              "on-delete": function($event) {
                                return _vm.onDeleteDocumentHandler($event)
                              },
                              "on-update": function($event) {
                                return _vm.onUpdateDocumentHandler($event)
                              }
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }